import { commonTypes } from '../common';

export const initialState = {
  installationAddress: {
    locationId: null,
    productId: null,
  },
};

const ApisNeedsInstallationReducer = (state, action) => {
  switch (action.type) {
    case commonTypes.SET_INSTALLATION_ADDRESS: {
      const { installationAddress } = action.payload;

      if (installationAddress.locationId) {
        return {
          ...state,
          installationAddress: {
            ...state.installationAddress,
            locationId: installationAddress.locationId,
            productId: installationAddress.productId || null,
            address: installationAddress.fullAddress,
            productType: installationAddress.productType,
          },
        };
      }

      return {
        ...state,
      };
    }
    case commonTypes.SET_INSTALLATION_ADDRESS_NAME: {
      const { address } = action.payload;
      return {
        ...state,
        installationAddress: {
          ...state.installationAddress,
          address,
        },
      };
    }
    default:
      return null;
  }
};

export const actions = {
  
};

export default ApisNeedsInstallationReducer;
